
export default function Bonus() {
  const bonuses = [
    {
      icon: 'ri-lightbulb-flash-fill',
      title: 'Criatividade é o Poder',
      description: 'Aprenda a desbloquear todo o potencial criativo do seu filho e transformar ideias em realidade.',
      color: 'neon-blue',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20creative%20mind%20explosion%20with%20holographic%20lightbulb%20and%20colorful%20ideas%20flowing%20from%20young%20person%20brain%20showing%20creativity%20power%20with%20blue%20neon%20lighting%20floating%20artistic%20symbols%20and%20innovation%20visualization%20in%20inspiring%20environment%20representing%20creative%20thinking%20and%20imagination%20development&width=600&height=400&seq=bonus1creativity&orientation=landscape'
    },
    {
      icon: 'ri-brain-fill',
      title: 'Como Desenvolver Sua Inteligência',
      description: 'Técnicas comprovadas para expandir capacidades cognitivas e acelerar o desenvolvimento intelectual.',
      color: 'neon-purple',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20holographic%20brain%20with%20glowing%20purple%20neural%20networks%20and%20intelligence%20enhancement%20visualization%20showing%20young%20person%20learning%20with%20floating%20knowledge%20symbols%20cognitive%20development%20icons%20and%20mental%20growth%20patterns%20in%20advanced%20environment%20representing%20intelligence%20expansion%20and%20brain%20development&width=600&height=400&seq=bonus2intelligence&orientation=landscape'
    },
    {
      icon: 'ri-shield-star-fill',
      title: 'Dominando Sua Vontade',
      description: 'Desenvolva disciplina, autocontrole e força de vontade para alcançar qualquer objetivo.',
      color: 'neon-pink',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20young%20person%20standing%20strong%20with%20glowing%20pink%20shield%20and%20willpower%20symbols%20showing%20determination%20and%20self%20control%20with%20floating%20discipline%20icons%20mental%20strength%20visualization%20and%20goal%20achievement%20patterns%20in%20powerful%20motivational%20environment%20representing%20willpower%20mastery%20and%20self%20discipline&width=600&height=400&seq=bonus3willpower&orientation=landscape'
    },
    {
      icon: 'ri-money-dollar-circle-fill',
      title: 'Como Eu Fiquei Rico',
      description: 'Estratégias reais de construção de riqueza e mentalidade financeira de sucesso.',
      color: 'neon-blue',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20wealth%20creation%20scene%20with%20holographic%20golden%20coins%20and%20financial%20success%20symbols%20showing%20young%20entrepreneur%20journey%20to%20riches%20with%20blue%20neon%20lighting%20floating%20money%20growth%20charts%20and%20prosperity%20visualization%20in%20luxurious%20inspiring%20environment%20representing%20wealth%20building%20and%20financial%20success%20strategies&width=600&height=400&seq=bonus4wealth&orientation=landscape'
    },
    {
      icon: 'ri-fire-fill',
      title: 'O Incrível Poder do Desconforto',
      description: 'Aprenda a abraçar desafios e usar o desconforto como combustível para crescimento extraordinário.',
      color: 'neon-purple',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20young%20person%20breaking%20through%20comfort%20zone%20barriers%20with%20glowing%20purple%20flames%20and%20transformation%20energy%20showing%20growth%20through%20challenge%20with%20floating%20strength%20symbols%20discomfort%20power%20visualization%20and%20personal%20breakthrough%20patterns%20in%20intense%20motivational%20environment%20representing%20growth%20mindset%20and%20resilience%20development&width=600&height=400&seq=bonus5discomfort&orientation=landscape'
    },
    {
      icon: 'ri-flashlight-fill',
      title: 'Energia e Liberdade',
      description: 'Descubra como cultivar energia ilimitada e conquistar a verdadeira liberdade pessoal.',
      color: 'neon-blue',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20young%20person%20radiating%20bright%20energy%20with%20glowing%20blue%20light%20and%20freedom%20symbols%20showing%20unlimited%20vitality%20and%20personal%20liberation%20with%20floating%20energy%20waves%20freedom%20wings%20and%20empowerment%20visualization%20in%20vibrant%20inspiring%20environment%20representing%20energy%20mastery%20and%20personal%20freedom%20achievement&width=600&height=400&seq=bonus6energy&orientation=landscape'
    }
  ];

  return (
    <section className="relative py-16 md:py-32 overflow-hidden">
      {/* Background Accent */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-neon-purple/5 to-transparent"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-20 space-y-4 md:space-y-6">
            <div className="inline-flex items-center gap-2 px-3 md:px-4 py-2 rounded-full bg-neon-pink/10 border border-neon-pink/30 backdrop-blur-sm">
              <i className="ri-gift-fill text-neon-pink text-sm md:text-base"></i>
              <span className="text-neon-pink text-xs md:text-sm font-semibold tracking-wide">BÔNUS EXCLUSIVOS</span>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight max-w-4xl mx-auto px-4">
              Bônus Que Vão
              <span className="block bg-gradient-to-r from-neon-pink via-neon-purple to-neon-blue bg-clip-text text-transparent mt-2"> Multiplicar os Resultados</span>
            </h2>

            <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4">
              6 módulos extras de alto valor para acelerar ainda mais o desenvolvimento do seu filho, exclusivo pra quem se matricular no curso completo.
            </p>
          </div>

          {/* Bonuses Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {bonuses.map((bonus, index) => (
              <div 
                key={index}
                className="group relative bg-dark-800/50 backdrop-blur-sm border border-neon-pink/20 rounded-2xl md:rounded-3xl overflow-hidden hover:border-neon-pink/50 transition-all duration-500 hover:shadow-[0_0_40px_rgba(255,20,147,0.3)] hover:-translate-y-2"
              >
                {/* Bonus Badge */}
                <div className="absolute top-3 md:top-4 left-3 md:left-4 z-10">
                  <div className="bg-gradient-to-r from-neon-pink to-neon-purple px-3 md:px-4 py-1 md:py-1.5 rounded-full">
                    <span className="text-white text-xs font-bold tracking-wide">BÔNUS #{index + 1}</span>
                  </div>
                </div>

                {/* Image */}
                <div className="relative h-40 md:h-48 overflow-hidden">
                  <img 
                    src={bonus.image}
                    alt={bonus.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-dark-800 via-dark-800/50 to-transparent"></div>
                  
                  {/* Icon */}
                  <div className={`absolute top-3 md:top-4 right-3 md:right-4 w-12 h-12 md:w-14 md:h-14 bg-${bonus.color}/20 backdrop-blur-md rounded-lg md:rounded-xl border border-${bonus.color}/40 flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${bonus.icon} text-xl md:text-2xl text-${bonus.color}`}></i>
                  </div>
                </div>

                {/* Content */}
                <div className="p-4 md:p-6 space-y-2 md:space-y-3">
                  <h3 className="text-lg md:text-2xl font-bold text-white group-hover:text-neon-pink transition-colors duration-300 leading-tight">
                    {bonus.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-300 leading-relaxed">
                    {bonus.description}
                  </p>
                </div>

                {/* Hover Glow Effect */}
                <div className={`absolute inset-0 bg-gradient-to-t from-${bonus.color}/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none`}></div>
              </div>
            ))}
          </div>

          {/* Value Statement */}
          <div className="mt-10 md:mt-16 text-center">
            <div className="inline-block bg-dark-800/50 backdrop-blur-sm border border-neon-pink/30 rounded-xl md:rounded-2xl p-6 md:p-8 max-w-2xl">
              <p className="text-gray-300 text-base md:text-lg mb-3 md:mb-4">
                Valor total dos bônus:
              </p>
              <p className="text-4xl md:text-5xl font-black bg-gradient-to-r from-neon-pink via-neon-purple to-neon-blue bg-clip-text text-transparent mb-2">
                R$ 3.000
              </p>
              <p className="text-neon-pink font-bold text-lg md:text-xl mb-3">
                Incluídos gratuitamente no curso integral!
              </p>
              <p className="text-gray-400 text-sm md:text-base">
                Estes bônus não são vendidos separadamente e estão disponíveis exclusivamente para quem se matricular no curso completo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
